import clsx from 'clsx'
import React from 'react'
import { ROUNDELS } from '../../common/props'
import { ucFirst } from '../../utils/common'
import useStyles from './Icon.styles'
import Image from '../Image/Image'
import { Box, Icon as MaterialIcon } from '@mui/material'

type Props = {
  icon: string
  label?: string
  className?: string
  fontSize?: 'inherit' | 'small' | 'large'
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void
  ariaLabel?: string
  roundel?: ROUNDELS
  dataTestId?: string
}

export const SVG_ICONS: Record<string, string> = {
  australia: 'flags/AUSTRALIA.svg',
  austria: 'flags/AUSTRIA.svg',
  belgium: 'flags/BELGIUM.svg',
  brazil: 'flags/BRAZIL.svg',
  canada: 'flags/CANADA.svg',
  china: 'flags/CHINA.svg',
  cyprus: 'flags/CYPRUS.svg',
  denmark: 'flags/DENMARK.svg',
  finland: 'flags/FINLAND.svg',
  france: 'flags/FRANCE.svg',
  germany: 'flags/GERMANY.svg',
  globe: 'flags/GLOBE.svg',
  greece: 'flags/GREECE.svg',
  holland: 'flags/HOLLAND.svg',
  'hong-kong': 'flags/HONG-KONG.svg',
  hungary: 'flags/HUNGARY.svg',
  india: 'flags/INDIA.svg',
  ireland: 'flags/IRELAND.svg',
  israel: 'flags/ISRAEL.svg',
  italy: 'flags/ITALY.svg',
  japan: 'flags/JAPAN.svg',
  malaysia: 'flags/MALAYSIA.svg',
  mexico: 'flags/MEXICO.svg',
  'new-zealand': 'flags/NEW-ZEALAND.svg',
  norway: 'flags/NORWAY.svg',
  poland: 'flags/POLAND.svg',
  portugal: 'flags/PORTUGAL.svg',
  romania: 'flags/ROMANIA.svg',
  russia: 'flags/RUSSIA.svg',
  singapore: 'flags/SINGAPORE.svg',
  'south-africa': 'flags/SOUTH-AFRICA.svg',
  spain: 'flags/SPAIN.svg',
  sweden: 'flags/SWEDEN.svg',
  switzerland: 'flags/SWITZERLAND.svg',
  turkey: 'flags/TURKEY.svg',
  uae: 'flags/UAE.svg',
  uk: 'flags/UK.svg',
  usa: 'flags/USA.svg',
}

const Icon = (props: Props) => {
  const { label, className, fontSize, onClick, ariaLabel, roundel, dataTestId } = props
  const icon = props.icon?.toLowerCase()
  const { classes } = useStyles()

  const svg = SVG_ICONS[icon]
  const titleIcon = ucFirst(icon)
  const Contents = () => (
    <>
      {svg ? (
        <Image
          imageUrl={`/images/icons/${svg}`}
          altText={`${titleIcon} Flag Icon`}
          className={clsx(fontSize && classes[fontSize], roundel && classes.roundel, roundel && classes[roundel])}
          height={24}
          width={24}
          loading="lazy"
          dataTestId={dataTestId}
        />
      ) : (
        <MaterialIcon
          {...(fontSize && { fontSize })}
          className={clsx(roundel && classes.roundel, roundel && classes[roundel], fontSize && classes[fontSize])}
          data-testid={dataTestId}
        >
          {icon}
        </MaterialIcon>
      )}
      {label && <div>{label}</div>}
    </>
  )
  const commonProps = {
    className: clsx(classes.iconContainer, className ?? ''),
    'aria-label': ariaLabel || 'icon',
  }

  return (
    <>
      {!!onClick ? (
        <Box component={'button'} type="button" onClick={onClick} style={{ cursor: 'pointer' }} {...commonProps}>
          <Contents />
        </Box>
      ) : (
        <Box component={'span'} {...commonProps}>
          <Contents />
        </Box>
      )}
    </>
  )
}

export default Icon
